var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480,272c0,45.9-14.9,88.3-40,122.7l126.6,126.7c12.5,12.5,12.5,32.8,0,45.3s-32.8,12.5-45.3,0L394.7,440 c-34.4,25.1-76.8,40-122.7,40c-114.9,0-208-93.1-208-208S157.1,64,272,64S480,157.1,480,272z M272,416c79.5,0,144-64.5,144-144 s-64.5-144-144-144s-144,64.5-144,144S192.5,416,272,416z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSolidFull);
export default __webpack_public_path__ + "static/media/magnifying-glass-solid-full.ae33719b9c8c2f83f5f6a71938423df6.svg";
export { ForwardRef as ReactComponent };